import axiosInstance from "./axiosinstance";

export interface Customer {
  id: string;
  customerName: string;
  plant: string;
  address: string;
  email: string;
  gstIn: string;
  phoneNo: string;
  equipmentName: string;
  amcAmount: number;
  isAMC: boolean;
  amcStartDate?: string;
  amcEndDate?: string;
}

export interface AddCustomer {
  customerName: string;
  plant: string;
  address: string;
  email: string;
  gstIn: string;
  phoneNo: string;
  equipmentName: string;
  amcAmount: number | "";
  isAMC: boolean;
  amcStartDate?: string;
  amcEndDate?: string;
}

export interface CustomerResponse {
  data: Customer[];
  totalCount: number;
}

export interface CustomerIdNameAddressPlant {
  id: string;
  customerName: string;
  plant: string;
  address: string;
  equipmentName: string;
}

export const customerRepository = {
 
  getcustomer: async (
    pageNumber: number,
    pageSize: number,
    search: string = ""
  ): Promise<CustomerResponse> => {
    const { data } =
      await axiosInstance.get<CustomerResponse>(
        "/api/customer",
        {
          params: {
            pageNumber,
            pageSize,
            search: search.trim(),
          },
        }
      );

    return data;
  },

  getcustomerById: async (
    id: string
  ): Promise<Customer> => {
    const { data } =
      await axiosInstance.get<Customer>(
        `/api/customer/${id}`
      );

    return data;
  },

  addcustomer: async (
    customer: AddCustomer
  ): Promise<Customer> => {
    const { data } =
      await axiosInstance.post<Customer>(
        "/api/customer",
        customer
      );

    return data;
  },

  updatecustomer: async (
    id: string,
    payload: AddCustomer
  ): Promise<Customer> => {
    const { data } =
      await axiosInstance.put<Customer>(
        `/api/customer/${id}`,
        payload
      );

    return data;
  },

  patchcustomer: async (
    id: string,
    payload: Partial<AddCustomer>
  ): Promise<Customer> => {
    const { data } =
      await axiosInstance.patch<Customer>(
        `/api/customer/${id}`,
        payload
      );

    return data;
  },

  getCustomerIdNameAddressPlant:
    async (): Promise<CustomerIdNameAddressPlant[]> => {
      const response =
        await axiosInstance.get(
          "/api/customer/id-name-address-plant"
        );

      return Array.isArray(
        response.data?.data
      )
        ? response.data.data
        : Array.isArray(response.data)
        ? response.data
        : [];
    },

  deletecustomer: async (
    id: string
  ): Promise<void> => {
    await axiosInstance.delete(
      `/api/customer/${id}`
    );
  },
};